export default {
  data_table: {
    delete_dialog: {
      button_yes: 'Delete',
      button_no: 'Cancel',
    },
  },
};
